// extracted by mini-css-extract-plugin
export default {"container":"StackTrace_container__sbknj"};